<div class="container-fluid client-list-container">
  <div class="row my-3">
    <div class="col">
        <div class="card p-2">
          <div>
            <button (click)="exportData()" class="btn btn-primary" style="position: absolute; right: 15px; width: 150px; height: 30px; padding: 0px; z-index: 10">Export</button>
          </div>
          <app-data-table [columns]="columns" [loadPage]="loadPage" [(filters)]="filters"
            [filtersComponent]="dataFilters" [pageSize]="20" (onReset)="onTableReset()" [tBodyTrAdditionalClass]="tBodyTrAdditionalClass">
            <app-data-filters #dataFilters>
              <app-data-filter-group>
                <app-data-filter-input label="Customer Name" [(model)]="filters.customerName"
                  placeholder="Customer Name"></app-data-filter-input>
                <app-data-filter-input label="Company Name" [(model)]="filters.company"
                  placeholder="Company Name">
                </app-data-filter-input>
              </app-data-filter-group>
            </app-data-filters>
          </app-data-table>

          <ng-template #customerName let-firstName="firstName" let-lastName="lastName">
            {{firstName}} {{lastName}}
          </ng-template>

          <ng-template #emailColumn let-firstEmail="firstEmail">
            {{firstEmail}}
          </ng-template>

          <ng-template #phoneColumn let-firstPhone="firstPhone">
            {{firstPhone}}
          </ng-template>

          <ng-template #registrationYearColumn let-createdAt="createdAt">
            {{createdAt | date: 'dd-MM-yyyy HH:mm'}}
          </ng-template>

          <ng-template #confirmedAtColumn let-confirmedAt="confirmedAt">
            {{confirmedAt | date: 'dd-MM-yyyy HH:mm'}}
          </ng-template>

          <ng-template #statusColumn let-status="status">
            {{status}}
          </ng-template>

          <ng-template #languageColumn let-language="language">
            {{language}}
          </ng-template>

          <ng-template #surveyAnswerColumn let-surveyAnswer="surveyAnswer">
            {{surveyAnswer}}
          </ng-template>

          <ng-template #companyNameColumn let-company="company">
            {{company.name}}
          </ng-template>

          <ng-template #companyEmailColumn let-company="company">
            {{company.firstEmail}}
          </ng-template>

          <ng-template #companyPhoneColumn let-company="company">
            {{company.firstPhone}}
          </ng-template>

          <ng-template #companyStatusColumn let-company="company">
            {{company.status}}
          </ng-template>

          <ng-template #events2019Column let-id="id">
            {{clientEvents2019.get(id) ? clientEvents2019.get(id) : 0}}
          </ng-template>

          <ng-template #events2020Column let-id="id">
            {{clientEvents2020.get(id) ? clientEvents2020.get(id) : 0}}
          </ng-template>

          <ng-template #events2021Column let-id="id">
            {{clientEvents2021.get(id) ? clientEvents2021.get(id) : 0}}
          </ng-template>

          <ng-template #events2022Column let-id="id">
            {{clientEvents2022.get(id) ? clientEvents2022.get(id) : 0}}
          </ng-template>

          <ng-template #events2023Column let-id="id">
            {{clientEvents2023.get(id) ? clientEvents2023.get(id) : 0}}
          </ng-template>

          <ng-template #events2024Column let-id="id">
            {{clientEvents2024.get(id) ? clientEvents2024.get(id) : 0}}
          </ng-template>

          <ng-template #events2025Column let-id="id">
            {{clientEvents2025.get(id) ? clientEvents2025.get(id) : 0}}
          </ng-template>

          <ng-template #events2026Column let-id="id">
            {{clientEvents2026.get(id) ? clientEvents2026.get(id) : 0}}
          </ng-template>
        </div>
    </div>
  </div>
</div>
